// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:17:39

export default {
  "id": "tricky-arrow",
  "slug": "tricky-arrow",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/9c8d14257d994f658a5084a23ceb0e5a-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/9c8d14257d994f658a5084a23ceb0e5a/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Tricky Arrow",
      "description": "Get ready to sharpen your skills in Tricky Arrow! Test your precision and reflexes as you shoot arrows at a spinning circle target. Aim for the bullseye and avoid hitting other arrows. With each twist and spin, the challenge grows, requiring strategy and accuracy. Simple yet addictive gameplay for all ages.",
      "instructions": "Aim and Shoot: Tap or click to shoot arrows at the spinning circle.\nAvoid Obstacles: Avoid hitting the other arrows already on the target.\nPrecision is Key: Aim carefully as the spinning target gets trickier with each level.\nAdvance Levels: Complete levels by successfully landing all your arrows.",
      "genres": [
        "Casual",
        "Shooter"
      ],
      "tags": [
        "aim",
        "arcade",
        "archery",
        "arrow",
        "challenge"
      ]
    },
    "zh-CN": {
      "title": "棘手之箭",
      "description": "准备好在《Tricky Arrow》中磨砺你的技能！测试你的精准度和反应速度，射击旋转的圆形靶心。瞄准靶心，避免击中其他箭矢。随着每一次的扭转和旋转，挑战不断升级，需要策略和精准度。简单却令人上瘾的游戏，适合所有年龄层。",
      "instructions": "瞄准射击：点击或点击射击箭头到旋转的圆圈。\n躲避障碍：避免击中目标上的其他箭头。\n精准是关键：随着旋转目标变得越来越困难，仔细瞄准。\n前进关卡：通过成功射中所有箭头来完成关卡。",
      "genres": [
        "休闲",
        "射击"
      ],
      "tags": [
        "瞄准",
        "街机",
        "射箭",
        "箭矢",
        "挑战"
      ]
    },
    "zh-TW": {
      "title": "難關之箭",
      "description": "準備好磨鋒你的技巧在《 tricky arrow ！\n\n測試你的準確度和反應速度，當你射箭向旋轉的圓形目標。瞄準十環，避免擊中其他箭矢。隨著每次的扭轉和旋轉，挑戰越來越大，需要策略和準確度。簡單但上癮的遊戲，適合所有年齡層。",
      "instructions": "準心射擊：點擊或滑鼠左鍵射箭擊中旋轉的圓圈。\n避開障礙：避免擊中目標上已經存在的箭矢。\n準確是關鍵：精準瞄准，隨著每個關卡旋轉目標變得越來越難。\n進階關卡：通過成功射中所有箭矢來完成關卡。",
      "genres": [
        "休闲",
        "射擊"
      ],
      "tags": [
        "瞄准",
        "電子遊戲",
        "射箭",
        "箭矢",
        "挑戰"
      ]
    },
    "zh-HK": {
      "title": "棘手之箭",
      "description": "準備好鍛煉你在「 tricky arrow 」中的技巧！測試你的準確度和反應速度，當你對著旋轉的圓形目標射箭。對準中心點，避免射中其他箭。隨著每次的轉動和旋轉，挑戰也隨之增加，需要策略和準確度。簡單又上癮的遊戲，適合所有年齡層。",
      "instructions": "標準射擊：點擊或按鈕射箭擊轉動的圓圈。\n避開障礙：避免擊中目標上已經存在的其他箭矢。\n準確是關鍵：仔細瞄准，因為隨著每個等級的升級，轉動目標會越來越難射擊。\n升級等級：通過成功射擊所有箭矢來完成等級。",
      "genres": [
        "休闲",
        "射擊"
      ],
      "tags": [
        "標靶",
        "電子遊戲",
        "射箭",
        "弓箭",
        "挑戰"
      ]
    },
    "ja": {
      "title": "トリッキーアロー",
      "description": "Tricky Arrowでスキルを鍛えましょう！回転する円形のターゲットに矢を射ることで、精度と反応を試してみてください。的を射るために狙い、他の矢に当たらないようにしてください。回転とスピンのたびに、挑戦が増え、戦略と精度が必要になります。シンプルだけど中毒性のあるゲームプレイで、どの世代も楽しめます。",
      "instructions": "アミとショット：回転する円に矢を射るためにタップまたはクリックしてください。\n障害物避け：ターゲット上に既に存在する他の矢に当たらないようにしてください。\n精度が鍵です：回転するターゲットはレベルごとに難しくなりますので、慎重に射る必要があります。\nレベルを進める：全ての矢を成功裏に当てることでレベルを完了してください。",
      "genres": [
        "カジュアル",
        "シューティング"
      ],
      "tags": [
        "狙撃",
        "アーケード",
        "アーチェリー",
        "矢",
        "挑戦"
      ]
    },
    "ko": {
      "title": "퍼즐화트 애로우",
      "description": "트리키 애로우에서 기술을 높이기 위해 준비하세요! 돌아가는 원형 타겟에 화살을 쏘며 정확성과 반사성을 테스트하세요. 중앙에 맞추고 다른 화살을 맞히지 않도록하세요. 각 돌기와 회전에 따라 도전이 증가하며 전략과 정확성이 필요합니다. 간단하지만 모든 연령대에게 매력적인 게임 플레이입니다.",
      "instructions": "mira하고 쏘기: 회전하는 원에 화살을 쏘기 위해 탭하거나 클릭하세요.\n 장애물 피하기: 타겟에 있는 다른 화살을 맞히지 마세요.\n 정확성이 중요합니다: 회전하는 타겟이 레벨마다 더 어려워지므로 신중히 맞추세요.\n 레벨 진행하기: 모든 화살을 성공적으로 맞추어 레벨을 완료하세요.",
      "genres": [
        "캐주얼",
        "쏘쏘게임"
      ],
      "tags": [
        "mira",
        "아케이드",
        "사격",
        "화살",
        "도전"
      ]
    },
    "fr": {
      "title": "Flèche Astucieuse",
      "description": "Préparez-vous à affûter vos compétences dans Tricky Arrow ! Testez votre précision et vos réflexes en tirant des flèches sur une cible circulaire tournante. Vissez le centre et évitez de toucher d'autres flèches. À chaque tour et rotation, le défi s'intensifie, nécessitant de la stratégie et de l'exactitude. Un gameplay simple mais accrocheur pour tous les âges.",
      "instructions": "Cible et Tirez : Tappez ou cliquez pour tirer des flèches vers le cercle tournant.\nÉvitez les Obstacles : Évitez de toucher les autres flèches déjà sur la cible.\nLa Précision est la Clé : Ciblez avec soin, car la cible tournante devient plus difficile à chaque niveau.\nAvancez dans les Niveaux : Terminez les niveaux en réussissant à poser toutes vos flèches.",
      "genres": [
        "Casual",
        "Tirs"
      ],
      "tags": [
        "aim",
        "arcade",
        "archery",
        "flèche",
        "défi"
      ]
    }
  }
};
